import { jsx as _jsx } from "react/jsx-runtime";
import { Step } from "@mui/material";
import { forwardRef } from "react";
export const UiStep = forwardRef((props, ref) => (_jsx(Step, Object.assign({ ref: ref }, props))));
//# sourceMappingURL=ui_step.js.map